import { Assert } from '@aura/core-lib';
import { LftModalBase } from '@lift/design-system-react-web/dist/components';
import React from 'react';
import { Header } from '../header/header.component';
import { Iframe } from '../iframe/iframe.component';
import ScreenError from '../screen-error/screen-error.component';
import Skeleton from '../skeleton/skeleton.component';
import S from './modal-conteudo.styles';
import { ModalProps } from './modal-conteudo.types';

export const ModalConteudo: React.FC<ModalProps> = ({
  asyncCursoComplementar,
  actionVoltar,
  exibirLabelVoltar,
  altoContraste,
  aside,
}) => {
  const { value: cursoComplementar, pendente, erro } = asyncCursoComplementar;

  if (pendente) {
    return <Skeleton />;
  }

  if (erro) {
    return (
      <ScreenError
        codigo="ERRO_AO_CARREGAR_CONTEUDO_DIGITAL_CURSO_COMPLEMENTAR"
        nomeTela={window.location.href}
      />
    );
  }

  Assert.nonNullable(cursoComplementar);

  return (
    <S.Container tabIndex={0} data-testid="modal-conteudo-curso-complementar">
      <LftModalBase
        ariaLabel={`Curso complementar ${cursoComplementar.titulo}`}
        size="lg"
        visible
        hiddenCloseButton
        lftClose={actionVoltar}
      >
        <Header
          curso={cursoComplementar}
          actionVoltar={actionVoltar}
          exibirLabelVoltar={exibirLabelVoltar}
          aside={aside}
        />
        <Iframe altoContraste={altoContraste} conteudo={cursoComplementar} />
      </LftModalBase>
    </S.Container>
  );
};
